import h from "../core/createElement";


export default function Label({ title, text }) {
    return (
        <article class="custom-label">
            <span class="title">{title}</span>
            <span class="text">{text}</span>
        </article>
    );
};